import { h } from 'hyperapp';
import Submit from '~/common/account/components/submit.jsx';
export default (({
  state
}) => h("div", {
  class: "actions mdui-clearfix"
}, h(Submit, {
  disabled: state.submitting,
  text: state.submitting ? '提交中…' : '提交'
})));